/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_GroupsInputs */

const en_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Groups`)
};

const fr_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupes d’événements`)
};

const de_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppen`)
};

const it_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppi di eventi`)
};

const ru_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы мероприятий`)
};

const es_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos`)
};

const zh_cn2_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组`)
};

const ja_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह`)
};

const pt_pt2_event_groups = /** @type {(inputs: Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Event Groups" |
*
* @param {Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_groups = /** @type {((inputs?: Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_groups(inputs)
	if (locale === "de") return de_event_groups(inputs)
	if (locale === "it") return it_event_groups(inputs)
	if (locale === "ru") return ru_event_groups(inputs)
	if (locale === "es") return es_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_event_groups(inputs)
	if (locale === "ja") return ja_event_groups(inputs)
	if (locale === "hi") return hi_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_event_groups(inputs)
	return en_event_groups(inputs)
});